import React from 'react';
import { downloadCsv } from '../../utils/csv';
import type { Cell } from '../../utils/csv';

interface CsvDownloadButtonProps {
  /** The whole file: the header row first, then one array per data row. */
  rows: Cell[][];
  filename: string;
  disabled?: boolean;
}

/** Downloads `rows` as a CSV that Excel opens correctly (UTF-8 byte order mark, CRLF line ends). */
const CsvDownloadButton: React.FC<CsvDownloadButtonProps> = ({ rows, filename, disabled = false }) => (
  <button type="button" className="btn btn-primary" disabled={disabled} onClick={() => downloadCsv(filename, rows)}>
    Export CSV
  </button>
);

export default CsvDownloadButton;
